import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import useValidationSchema, { FieldConfig } from "../../../components/Validations";
import Toast from "../../../helpers/Toast";
import { SearchByClientName } from "../../../models/Client/SearchByClientName";
import { CreateEquipmentDTO } from "../../../models/Equipment/CreateEquipmentDTO";
import { ClientService } from "../../../services/ClientService";
import { EquipmentService } from "../../../services/EquipmentService";
import ButtonComponent from "../../ButtonComponent";
import InputComponent from "../../InputComponent";
import SearchSelectComponent from "../../SearchSelectComponent";
import { SelectItemsProps } from "../../Select2Component";

export default function EquipmentCreateB() {
    const intl = useIntl();
    const navigate = useNavigate();
    const clientService = new ClientService();
    const equipmentService = new EquipmentService();

    //Loadings
    const [isButtonCreateLoading, setIsButtonCreateLoading] = useState<boolean>(false);

    const [clientSelected, setclientSelected] = useState<SelectItemsProps | null>(null);
    const [equipment, setEquipment] = useState<CreateEquipmentDTO>({} as CreateEquipmentDTO);

    const fields: FieldConfig[] = [
        ["clientErpId", "string", "Screens.Equipments.Create.ClientRequired"],
        ["carPlate", "string", "Screens.Equipments.Create.CarPlateRequired"],   // posteriomente poderá fazer sentido uma expressão regular para restringir
        ["serialNumber", "string", "Screens.Equipments.Create.SerialNumberRequired"],
        ["brand", "string", "Screens.Equipments.Create.BrandRequired"],
        ["model", "string", "Screens.Equipments.Create.ModelRequired"],

    ];

    const schemaValidation = useValidationSchema(fields);

    const createEquipment = async () => {
        setIsButtonCreateLoading(false);

        const createEquipment: CreateEquipmentDTO = {
            erpId: null,
            name: equipment?.name ?? null,
            carPlate: equipment?.carPlate ?? null,
            carPlateValidation: true,
            serialNumber: equipment?.serialNumber ?? null,
            brand: equipment?.brand ?? null,
            model: equipment?.model ?? null,
            sku: equipment?.sku ?? null,
            clientErpId: clientSelected?.value ?? null,
        };

        const { error } = schemaValidation.validate(createEquipment);
        if (error) {
            Toast.Show("error", error.details.map(detail => detail.message).join(', '));
            setIsButtonCreateLoading(false);
            return;
        }

        const response = await equipmentService.Create(createEquipment);

        if (response.success !== true) {
            Toast.Show("error", response.message);
            setIsButtonCreateLoading(false);
            return;
        }

        Toast.Show("success", response.message);
        setIsButtonCreateLoading(false);
        navigate(-1);
    };

    const GetByClient = async (value: string): Promise<SelectItemsProps[]> => {
        var data: SearchByClientName = {
            name: value,
        };
        var response = await clientService.SearchByName(data);
        if (response.success === false || response.obj === null) {
            Toast.Show("error", response.message);
            return [];
        }

        const list: SelectItemsProps[] = [];

        response.obj.forEach((element: any) => {
            var item: SelectItemsProps = {
                value: element.erpId,
                label: element.name,
            };
            list.push(item);
        });

        return list;
    };

    return (
        <>
            <div>
                <Col xl={6}>
                    <label style={{ margin: "0px", padding: "13px" }}>
                        <b>
                            <FormattedMessage id="Screens.EquipmentCreate.SubTitle2" />
                        </b>
                    </label>
                    <Row
                        style={{
                            margin: "0px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >
                        <SearchSelectComponent
                            xl={14}
                            lg={14}
                            md={14}
                            sm={14}
                            xs={14}
                            label={intl.formatMessage({
                                id: "Screens.Equipments.Info.Client",
                            })}
                            loadOptions={GetByClient}
                            onChange={(e) => {
                                setclientSelected(e);
                            }}
                            value={clientSelected}
                            style={{ width: "100%" }}
                        />
                    </Row>

                    <label style={{ margin: "0px", padding: "13px" }}>
                        <b>
                            <FormattedMessage id="Screens.EquipmentCreate.SubTitle" />
                        </b>
                    </label>
                    <Row
                        style={{
                            margin: "0px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >
                        <InputComponent
                            xl={3}
                            lg={4}
                            md={5}
                            sm={12}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={equipment?.carPlate}
                            label={intl.formatMessage({
                                id: "Screens.Equipments.Info.CarPlate",
                            })}
                            readOnly={false}
                            onChange={(carPlate: string) => {
                                setEquipment({ ...equipment!, carPlate: carPlate });
                            }}
                        />

                        <InputComponent
                            xl={3}
                            lg={4}
                            md={5}
                            sm={12}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={equipment?.serialNumber}
                            label={intl.formatMessage({
                                id: "Screens.Equipments.Info.SerialNumber",
                            })}
                            readOnly={false}
                            onChange={(serialNumber: string) => {
                                setEquipment({ ...equipment!, serialNumber: serialNumber });
                            }}
                        />

                        <InputComponent
                            xl={3}
                            lg={4}
                            md={5}
                            sm={12}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={equipment?.brand}
                            label={intl.formatMessage({
                                id: "Screens.Equipments.Info.Brand",
                            })}
                            readOnly={false}
                            onChange={(brand: string) => {
                                setEquipment({ ...equipment!, brand: brand });
                            }}
                        />

                        <InputComponent
                            xl={3}
                            lg={4}
                            md={5}
                            sm={12}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={equipment?.model}
                            label={intl.formatMessage({
                                id: "Screens.Equipments.Info.Model",
                            })}
                            readOnly={false}
                            onChange={(model: string) => {
                                setEquipment({ ...equipment!, model: model });
                            }}
                        />
                    </Row>

                    <Row
                        style={{
                            margin: "0px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >
                        <InputComponent
                            xl={3}
                            lg={4}
                            md={5}
                            sm={12}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={equipment?.sku}
                            label={intl.formatMessage({
                                id: "Screens.Equipments.Info.Sku",
                            })}
                            readOnly={false}
                            onChange={(sku: string) => {
                                setEquipment({ ...equipment!, sku: sku });
                            }}
                        />
                    </Row>
                </Col>
                <Row style={{ margin: "0px", padding: "0px" }}>
                    <Col xl={1} lg={1} md={1} sm={1} xs={1}>
                        <ButtonComponent
                            loading={isButtonCreateLoading}
                            style={{ width: "100%", marginTop: "10px" }}
                            text={intl.formatMessage({ id: "EquipmentCreateB.Save" })}
                            onClick={() => createEquipment()}
                        />
                    </Col>
                </Row>
            </div>
        </>
    );
}
